import {
  CLEAR_ADDTOBASKET_MESSAGE,
  CLEAR_ERRORS,
  CLEAR_INFO_MESSAGE,
  CLEAR_SUCCESS_MESSAGE,
  CLEAR_WARNING_MESSAGE,
  SET_ADDTOBASKET_MESSAGE,
  SET_ERRORS,
  SET_INFO_MESSAGE,
  SET_SUCCESS_MESSAGE,
  SET_WARNING_MESSAGE,
} from "./alertsTypes";

export interface AlertsState {
  success: string | null;
  errors: string[] | null;
  warnings: string[] | null;
  info: string[] | null;
  addToBasket: string | null;
}

const initialAlerts = {
  success: null,
  errors: null,
  warnings: null,
  info: null,
  addToBasket: null,
};

const alertsReducer = (alerts = initialAlerts, action: any) => {
  switch (action.type) {
    case SET_WARNING_MESSAGE:
      return { ...alerts, warnings: action.payload };
    case CLEAR_WARNING_MESSAGE:
      return { ...alerts, warnings: null };
    case SET_ERRORS:
      return { ...alerts, errors: action.payload };
    case CLEAR_ERRORS:
      return { ...alerts, errors: null };
    case SET_INFO_MESSAGE:
      return { ...alerts, info: action.payload };
    case CLEAR_INFO_MESSAGE:
      return { ...alerts, info: null };
    case CLEAR_SUCCESS_MESSAGE:
      return { ...alerts, success: null };
    case SET_SUCCESS_MESSAGE:
      return { ...alerts, success: action.payload };
    case SET_ADDTOBASKET_MESSAGE:
      return { ...alerts, addToBasket: action.payload };
    case CLEAR_ADDTOBASKET_MESSAGE:
      return { ...alerts, addToBasket: null };

    default:
      return alerts;
  }
};

export default alertsReducer;
